import { useEffect, useState } from 'react'
import Badge from '@mui/material/Badge'
import IconButton from '@mui/material/IconButton'
import NotificationsOutlined from '@mui/icons-material/NotificationsOutlined'
import { useNotificationStore } from '../../stores/notificationStore'
import NotificationCenter from '../NotificationCenter'

interface NotificationBellProps {
  userId: string
}

export default function NotificationBell({ userId }: NotificationBellProps) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
  const unreadCount = useNotificationStore(state => state.unreadCount)
  const subscribe = useNotificationStore(state => state.subscribe)

  useEffect(() => {
    const unsubscribe = subscribe(userId)
    return () => {
      unsubscribe()
    }
  }, [userId, subscribe])

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <>
      <IconButton
        color='inherit'
        onClick={handleClick}
        aria-label='notifications'
      >
        <Badge
          badgeContent={unreadCount}
          color='error'
          invisible={unreadCount === 0}
        >
          <NotificationsOutlined />
        </Badge>
      </IconButton>
      <NotificationCenter anchorEl={anchorEl} onClose={handleClose} />
    </>
  )
}
